export const CURRENCY_SYMBOLS = {
  EUR: '€', // Euro
  DKK: 'kr', // Danish Krone
  SEK: 'kr', // Swedish Krona
  INR: '₹', // Indian Rupee
} as const;

type ObjectValues<T> = T[keyof T];
export type CurrencySymbolType = ObjectValues<typeof CURRENCY_SYMBOLS>;
